module.exports = __webpack_public_path__ + "static/media/path-d.024e592c.svg";